<template>
  <div
    class="absolute top-0 left-0 size-full bg-white/90 z-50 flex items-center justify-center"
  >
    <SymbolLoader class="w-80" />
  </div>
</template>
